<div class="no-delay-printing-container">
  <div class="wd-100">
    <img class="wd-100" [src]="images.NO_EVENTS_DELAY_IMG" alt="no-delay" />
  </div>
  <div class="no-dp-body ta_center">
    <div class="no-dp-title">
      {{ 'PRINTER_STATUS.NO_PRINT_DELAY_DETECTED' | fallbackTranslate }}
    </div>
    <div class="no-dp-description">
      {{
        'PRINTER_STATUS.ORDERS_NOT_PRINTED_WITHIN_3_MIN_WILL_SHOW'
          | fallbackTranslate
      }}
    </div>
    <button class="got-it-btn" (click)="gotItBtnClicked()">
      {{ 'PRINTER_STATUS.GOT_IT' | fallbackTranslate }}
    </button>
  </div>
</div>
